import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ResourceType } from '../api/common';
import { buildResourceTypeDisplayName } from '../../labels/utils';

const resourcesNotInOptions = [
  // A list of resources that should not appear in the select options.
  ResourceType.application,
  ResourceType.dataverse_user,
  ResourceType.portal_list,
];

const allResourceTypes = (Array.from(Object.keys(ResourceType)) as (keyof typeof ResourceType)[]).map(
  (resourceStr) => ResourceType[resourceStr]
);
const resourcesInOptions = allResourceTypes.filter((resource) => !resourcesNotInOptions.includes(resource));

export const ResourceTypeSelectOptions: ISelectOption[] = resourcesInOptions
  .map((resourceType: ResourceType) => ({
    id: `${FilterTypesEnum.ResourceType}-${resourceType}`,
    value: resourceType,
    displayName: buildResourceTypeDisplayName(resourceType),
    categoryName: FilterTypesEnum.ResourceType.toString(),
    filterType: FilterTypesEnum.ResourceType,
    withoutBeautifyDisplayName: true,
  }))
  .sort((filterOption1, filterOption2) => filterOption1.displayName.localeCompare(filterOption2.displayName));
